<ion-spinner [name]="name()" [class]="cssClass()"></ion-spinner>
